import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import { AuthContext } from "./AuthContext";
import ReactDom from "react-dom";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import GuestbookLight from "../UI/Icons/GuestbookLight";
import Button from "../UI/Button";
import CashBack from "../UI/Icons/CashBack";
import Hotel from "../UI/Icons/Hotel";
import AddUser from "../UI/Icons/AddUser";
import Snooze from "../UI/Icons/Snooze";
import SackDollar from "../UI/Icons/SackDollar";
import { numOfHotels, langHash } from "../../settings/IntegrationConstants";
import { BookingEngine } from "../../hotel_integration_modules/index";
import translations from "../../hotel_integration_modules/utilities/translations";
import I18n from "../../translations/i18n";
import UseWindowWidth from "../../hooks/UseWindowWidth";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core";
import onContentChange from "../../hotel_integration_modules/utilities/onContentChange";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

type FixedWidgetContainerProps = {
  width: string;
  positionTop: string;
  positionRight: string;
  positionBottom: string;
  positionLeft: string;
};

const FixedWidgetContainer = styled.div<FixedWidgetContainerProps>`
  position: fixed !important;
  min-width: 260px !important;
  max-width: 340px !important;
  width: ${({ width }) => width}px !important;
  top: ${({ positionTop }) => (positionTop === "" ? "unset" : positionTop)} !important;
  right: ${({ positionRight }) =>
    positionRight === "" ? "unset" : positionRight} !important;
  bottom: ${({ positionBottom }) =>
    positionBottom === "" ? "unset" : positionBottom} !important;
  left: ${({ positionLeft }) => (positionLeft === "" ? "unset" : positionLeft)} !important;
  z-index: 2147483647 !important;
`;

const NonFixedWidgetcontainer = styled.div<{ isDesktopWidget: boolean }>`
  margin-top: ${({ isDesktopWidget }) => (isDesktopWidget ? "24px" : "0px")} !important;

  ${({ theme }) =>
    theme.tablet`
      text-align: left !important;
  `}
`;

const WidgetHeaderContainer = styled.div`
  display: flex !important;
`;

const GuestbookIconContainer = styled.div`
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  margin-right: 12px !important;

  svg {
    height: 30px !important;
    width: 32px !important;
  }
`;

const WidgetHeader = styled.div`
  font-size: 15px !important;
  font-weight: 600 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
`;

const WidgetContentContainer = styled(Accordion)`
  font-family: ${({ theme }) => theme.primaryFont} !important;
  box-shadow: 0px 4px 12px rgb(0 0 0 / 15%) !important;
  width: fit-content !important;
  .MuiIconButton-root {
    padding: 6px !important;
  }
`;

const OuterAccordionSummary = styled(AccordionSummary)`
  min-height: unset !important;
  height: 48px !important;
  color: ${({ theme }) => theme.secondaryColor}!important;
  padding: 5px 20px !important;
  right: 0 !important;
  z-index: 2 !important;
  background-color: ${({ theme }) => theme.primaryColor}!important;
  margin: 0 !important;
  position: relative !important;
  top: 0 !important;
  box-shadow: none !important;

  .MuiSvgIcon-root {
    fill: #ffffff !important;
  }
`;

const OuterAccordionDetails = styled(AccordionDetails)`
  flex-direction: column !important;
`;

const Filler = styled.div`
  border-bottom: 4px solid ${({ theme }) => theme.primaryColor} !important;
  width: 100% !important;
  position: absolute !important;
  margin-left: -16px !important;
  top: 40px !important;
`;

const WidgetDescription = styled.div`
  font-size: 14px !important;
  line-height: 21px !important;

  a {
    margin-right: 6px !important;
    color: ${({ theme }) => theme.primaryColor} !important;
  }
`;

const NextStepsText = styled.div`
  margin-top: 8px !important;
  font-size: 14px !important;
  line-height: 21px !important;
`;

const ButtonContainer = styled.div`
  display: flex !important;
  margin-top: 16px !important;

  input {
    margin-right: 12px !important;
  }
`;

const Line = styled.div`
  border-bottom: 1px solid #e5e5e5 !important;
  margin: 16px 0px !important;
`;

const InnerAccordionContainer = styled(Accordion)`
  box-shadow: none !important;
  margin: 0 !important;

  &::before {
    display: none !important;
  }
`;

const InnerAccordionSummary = styled(AccordionSummary)`
  min-height: unset !important;
  height: 16px !important;
  padding: 0 !important;

  .MuiSvgIcon-root {
    fill: #343638;
  }
`;

const InnerSectionTitle = styled.div`
  font-size: 15px !important;
  font-weight: 600 !important;

  a {
    color: ${({ theme }) => theme.primaryColor} !important;
  }
`;

const InnerAccordionDetails = styled(AccordionDetails)`
  padding: 0 !important;
  margin-top: 6px !important;
  flex-direction: column !important;
`;

const Reward = styled.div`
  margin: 8px 0px 4px !important;
  display: flex !important;
  font-size: 14px !important;
  line-height: 21px !important;
`;

const RewardText = styled.div`
  color: ${({ theme }) => theme.primaryColor} !important;
  font-weight: 700 !important;
`;

const RewardDesc = styled.span`
  color: #666666 !important;
  font-weight: 400 !important;
`;

const IconContainer = styled.span`
  margin-right: 4px !important;
  position: relative !important;
  top: 3px !important;
  svg {
    path {
      fill: ${({ theme }) => theme.primaryColor} !important;
    }
    height: 16px !important;
    width: 16px !important; 
  }
`;

const LogoutLink = styled.span`
  border-bottom: 1px solid #444a58 !important;
  cursor: pointer !important;

  &:hover {
    color: ${({ theme }) => theme.primaryColor} !important;
    border-bottom: 2px solid ${({ theme }) => theme.primaryColor} !important;
  }
`;

type WidgetProps = {
  handleOpen: (modalSection: string) => void;
  existingMember: boolean;
  gbEnrollChecked: boolean;
  userLoggedIn: boolean;
  bookingEngine: BookingEngine;
  hotelSettings: any;
  locale: string;
  widgetMobileAtWidth: number;
  autoExpandOnLoad?: boolean;
  setOuterAccordionExpanded: (e: any) => void;
  outerAccordionExpanded: boolean;
};

type WidgetContentProps = {
  handleOpen: (modalSection: string) => void;
  existingMember: boolean;
  gbEnrollChecked: boolean;
  userLoggedIn: boolean;
  bookingEngine: BookingEngine;
  hotelSettings: any;
  locale: string;
  isDesktopWidget: boolean;
  autoExpandOnLoad?: boolean;
  setOuterAccordionExpanded: (e: any) => void;
  outerAccordionExpanded: boolean;
  widgetMobileAtWidth: number;
};

const WidgetContent = ({
  handleOpen,
  existingMember,
  gbEnrollChecked,
  userLoggedIn,
  bookingEngine,
  hotelSettings,
  locale,
  isDesktopWidget,
  autoExpandOnLoad,
  setOuterAccordionExpanded,
  outerAccordionExpanded,
  widgetMobileAtWidth,
}: WidgetContentProps) => {
  const authContext: any = useContext(AuthContext);

  const mountedRef = useRef(true);
  const widgetLoginEnabled = hotelSettings.widget.loginEnabled;
  const whiteLabel = hotelSettings.hotel.whiteLabel;
  const cobrandingEnabled = hotelSettings.hotel.cobrandingEnabled;
  const expandEnabled = hotelSettings.widget.expandEnabled;
  const rootNode = bookingEngine.shadowRoot || document;

  const setAccordionExpanded = useCallback(async () => {
    setTimeout(() => {
      if (mountedRef.current) {
        sessionStorage.setItem("onLoadModalExpanded", "true");
        if (
          autoExpandOnLoad &&
          sessionStorage.getItem("onLoadModalExpanded") === "true"
        ) {
          sessionStorage.setItem("gbWidgetExpanded", "true");
          setOuterAccordionExpanded(true);
        }
      }
    }, 2000);
  }, [mountedRef, autoExpandOnLoad]);

  useEffect(() => {
    library.add(fas);
  }, []);

  useEffect(() => {
    if (
      sessionStorage.getItem("onLoadModalExpanded") !== "true" &&
      !gbEnrollChecked &&
      !existingMember &&
      isDesktopWidget &&
      expandEnabled
    ) {
      setAccordionExpanded();
    }
    return () => {
      mountedRef.current = false;
    };
  }, [existingMember, gbEnrollChecked, isDesktopWidget, setAccordionExpanded]);

  const [rewards15, setRewards15] = useState(
    Number(bookingEngine.getRewards(0.15)).toFixed(0)
  );

  onContentChange(
    bookingEngine.selectors.paymentPage.contentChangeTarget,
    () => {
      sessionStorage.removeItem("gbRewards15");
      sessionStorage.removeItem("gbRewards05");
      setRewards15(Number(bookingEngine.getRewards(0.15)).toFixed(0));
    },
    rootNode 
  );
  const currency = bookingEngine.getCheckoutCurrency()
    || bookingEngine.getRatesCurrency();

  const logout = (): void => {
    authContext.logout();
    bookingEngine.clearMemberCode();
    sessionStorage.setItem('gbEmail', '');
    sessionStorage.setItem('gbEnrolledChecked', 'false');
  };

  const expandOuterAccordion = (): void => {
    setOuterAccordionExpanded(!outerAccordionExpanded);
    sessionStorage.setItem(
      "gbWidgetExpanded",
      (!outerAccordionExpanded).toString()
    );
  };

  const useStyles = makeStyles(() => ({
    root: {
      borderRadius: isDesktopWidget ? "5px !important" : "0px !important",
    },
  }));

  const allBenefits = bookingEngine.hotel.benefits;
  let benefitsCorrectLanguage: any[] = [];
  let windowLanguage = document.documentElement.lang;
  if (windowLanguage.indexOf("-") !== -1) {
    windowLanguage = windowLanguage.split("-")[0];
  }

  let windowLanguageId = Object.keys(langHash)[
    Object.values(langHash).indexOf(windowLanguage)
  ];

  allBenefits.forEach((item: any) => {
    if (windowLanguageId === "2") {
      if (item.language_id === 2) {
        benefitsCorrectLanguage.push(item);
      }
    } else if (
      windowLanguageId !== "2" &&
      item.language_id === windowLanguageId
    ) {
      benefitsCorrectLanguage.push(item);
    }
  });

  // expand Additional Member Benefits section by default
  const [expanded, setExpanded] = React.useState("panel3");
  const handleChange = (panel: any) => (event: any, newExpanded: any) => {
    setExpanded(newExpanded ? panel : false);
  };

  // detect mobile and disable onCLick accordingly
  const [isTouch, setIsTouch] = React.useState(
    typeof document !== "undefined" &&
    "ontouchstart" in document.documentElement
  );

  return (
    <WidgetContentContainer expanded={outerAccordionExpanded} className="gb-widget-header">
      <OuterAccordionSummary
        onClick={isTouch ? undefined : () => expandOuterAccordion()}
        onTouchStart={() => expandOuterAccordion()}
        onKeyPress={() => expandOuterAccordion()}
        expandIcon={<ExpandMoreIcon className="expand-more-icon" />}
        classes={{ root: useStyles().root }}
        className="outer-accordion-summary"
      >
        <WidgetHeaderContainer>
          <GuestbookIconContainer className="gb-widget-header-logo">
            <GuestbookLight />
          </GuestbookIconContainer>
          {Number(rewards15) > 0 ? (
            gbEnrollChecked || existingMember || userLoggedIn ? (
              <WidgetHeader className="gb-widget-header-text">
                <div>
                  {I18n.t(
                    `views.hotel_integration.components.widget.cash_rewards_earned`,
                    {
                      locale: `${locale}`,
                      reward_amount: `${currency}${rewards15}`,
                    }
                  )}
                </div>
              </WidgetHeader>
            ) : (
              <WidgetHeader>
                {I18n.t(
                  `views.hotel_integration.components.widget.members_earn`,
                  {
                    locale: `${locale}`,
                    reward_amount: `${currency}${rewards15}`,
                  }
                )}
              </WidgetHeader>
            )
          ) : (
            <WidgetHeader>{`${translations(
              "widget",
              "earn_fifteen",
              locale
            )} `}</WidgetHeader>
          )}
        </WidgetHeaderContainer>
      </OuterAccordionSummary>
      <OuterAccordionDetails>
        {gbEnrollChecked || existingMember || userLoggedIn ? (
          <WidgetDescription>
            {userLoggedIn && authContext.first_name
              ? I18n.t(
                `views.hotel_integration.components.widget.as_guestbook_member_with_name`,
                {
                  locale: `${locale}`,
                  name: `${authContext.first_name}`,
                }
              )
              : `${translations("widget", "as_guestbook_member", locale)} `}
            <>
              {window.gb_data.hotel.name}{" "}
              {I18n.t(`views.hotel_integration.components.widget.and`)}{" "}
            </>
            <a
              href="https://theguestbook.com/destinations/guestbook"
              target="_blank"
              rel="noreferrer"
              style={{ wordBreak: "initial" }}
            >
              {(cobrandingEnabled) ? (
                I18n.t(`views.hotel_integration.components.widget.num_hotels_cobrand`, {
                  locale: `${locale}`,
                  num_of_hotels: numOfHotels
                })
              ) : (
                I18n.t(`views.hotel_integration.components.widget.num_hotels`, {
                  locale: `${locale}`,
                  num_of_hotels: numOfHotels
                })
              )}
            </a>
            {userLoggedIn && (
              <>
                {"  "}
                <LogoutLink
                  tabIndex={0}
                  role="button"
                  onClick={() => logout()}
                  onKeyPress={() => logout()}
                  id="gb-logout-link"
                >
                  {`${translations("widget", "logout", locale)} `}
                </LogoutLink>
              </>
            )}
          </WidgetDescription>
        ) : (
          <>
            <WidgetDescription>
              {(cobrandingEnabled) ? (
                `${I18n.t(`views.hotel_integration.components.widget.join_guestbook_cobrand`, {
                  locale: `${locale}`,
                  white_label: `${whiteLabel}`
                })} `
              ) : (
                `${translations("widget", "join_guestbook", locale)} `
              )}
              <>
                {window.gb_data.hotel.name}{" "}
                {I18n.t(`views.hotel_integration.components.widget.and`)}
              </>{" "}
              <a
                href="https://theguestbook.com/destinations/guestbook"
                target="_blank"
                rel="noreferrer"
                style={{ wordBreak: "initial" }}
              >
                {(cobrandingEnabled) ? (
                  I18n.t(`views.hotel_integration.components.widget.num_hotels_cobrand`, {
                    locale: `${locale}`,
                    num_of_hotels: numOfHotels
                  })
                ) : (
                  I18n.t(`views.hotel_integration.components.widget.num_hotels`, {
                    locale: `${locale}`,
                    num_of_hotels: numOfHotels
                  })
                )}
              </a>
            </WidgetDescription>
            {widgetLoginEnabled ? (
              // LOGIN ENABLED
              <ButtonContainer className="button-container">
                <Button
                  kind="bei2"
                  type="button"
                  onClick={() => handleOpen("signup")}
                  small={true}
                  className="gb-signup"
                >
                  {`${translations("widget", "sign_up", locale)}`}
                </Button>
                <Button
                  kind="bei2"
                  type="button"
                  onClick={() => handleOpen("login")}
                  inverted={true}
                  small={true}
                  className="gb-login"
                >
                  {`${translations("widget", "login", locale)}`}
                </Button>
              </ButtonContainer>
            ) : (
              // LOGIN DISABLED
              <NextStepsText>
                {`${translations("widget", "join_at_checkout", locale)}`}
              </NextStepsText>
            )}
          </>
        )}
        <Line className="line" />
        <InnerAccordionContainer
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          className="inner-accordion-container"
        >
          <InnerAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <InnerSectionTitle>
              {`${translations("widget", "redeem_after", locale)}`}
            </InnerSectionTitle>
          </InnerAccordionSummary>
          <InnerAccordionDetails>
            <Reward>
              <RewardText>
                <IconContainer>
                  <CashBack />
                </IconContainer>
                {translations("widget", "cash_back.title", locale)}{" "}
                <RewardDesc>
                  {translations("widget", "cash_back.description", locale)}
                </RewardDesc>
              </RewardText>
            </Reward>
            <Reward>
              <RewardText>
                <IconContainer>
                  <Hotel />
                </IconContainer>
                {translations("widget", "cash_forward.title", locale)}{" "}
                <RewardDesc>
                  {translations("widget", "cash_forward.description", locale)}
                </RewardDesc>
              </RewardText>
            </Reward>
          </InnerAccordionDetails>
        </InnerAccordionContainer>
        <Line className="line" />
        <InnerAccordionContainer
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
          className="inner-accordion-container"
        >
          <InnerAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <InnerSectionTitle>
              {`${translations("widget", "how_it_works", locale)} `}
              <a
                href="https://theguestbook.com/faq"
                target="_blank"
                rel="noreferrer"
              >{`${translations("widget", "faq", locale)}`}</a>
            </InnerSectionTitle>
          </InnerAccordionSummary>
          <InnerAccordionDetails>
            <Reward>
              <RewardText>
                <IconContainer>
                  <AddUser />
                </IconContainer>
                {translations("widget", "join.title", locale)}{" "}
                <RewardDesc>
                  {translations("widget", "join.description", locale)}
                </RewardDesc>
              </RewardText>
            </Reward>
            <Reward>
              <RewardText>
                <IconContainer>
                  <Snooze />
                </IconContainer>
                {translations("widget", "book_direct.title", locale)}{" "}
                <RewardDesc>
                  {translations("widget", "book_direct.description", locale)}
                </RewardDesc>
              </RewardText>
            </Reward>
            <Reward>
              <RewardText>
                <IconContainer>
                  <SackDollar />
                </IconContainer>
                {translations("widget", "redeem.title", locale)}{" "}
                <RewardDesc>
                  {translations("widget", "redeem.description", locale)}
                </RewardDesc>
              </RewardText>
            </Reward>
          </InnerAccordionDetails>
        </InnerAccordionContainer>
        {benefitsCorrectLanguage.length > 0 && (
          <>
            <Line />
            <InnerAccordionContainer
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
              className="inner-accordion-container"
            >
              <InnerAccordionSummary expandIcon={<ExpandMoreIcon />}>
                {(cobrandingEnabled) ? (
                  <InnerSectionTitle>
                    {I18n.t(
                      `views.hotel_integration.components.widget.additional_member_benefits_cobrand`, {
                      locale: `${locale}`,
                      white_label: `${whiteLabel}`
                    })}
                  </InnerSectionTitle>
                ) : (
                  <InnerSectionTitle>
                    {`${translations(
                      "widget",
                      "additional_member_benefits",
                      locale
                    )} `}
                  </InnerSectionTitle>
                )}
              </InnerAccordionSummary>
              <InnerAccordionDetails>
                {benefitsCorrectLanguage?.map((benefit: any, index: any) => {
                  return (
                    <Reward key={index}>
                      <RewardText>
                        <IconContainer style={{ top: "0" }}>
                          <FontAwesomeIcon icon={benefit.icon_class} />
                        </IconContainer>
                        <RewardDesc>{benefit.description}</RewardDesc>
                      </RewardText>
                    </Reward>
                  );
                })}
              </InnerAccordionDetails>
            </InnerAccordionContainer>
          </>
        )}
      </OuterAccordionDetails>
    </WidgetContentContainer>
  );
};

const Widget = ({
  handleOpen,
  existingMember,
  gbEnrollChecked,
  userLoggedIn,
  bookingEngine,
  hotelSettings,
  locale,
  widgetMobileAtWidth,
  autoExpandOnLoad,
  outerAccordionExpanded,
  setOuterAccordionExpanded,
}: WidgetProps) => {
  const WindowWidth = UseWindowWidth();
  const [stickyWidgetVisible, setStickyWidgetVisible] = useState(false);
  const isDesktopWidget = WindowWidth > widgetMobileAtWidth - 1;

  if (bookingEngine.widgetFixedPosition && isDesktopWidget) {
    return (
      <FixedWidgetContainer
        id="guestbook-widget-desktop"
        width={bookingEngine.hotel.widgetWidth}
        positionTop={bookingEngine.hotel.widgetPositionTop}
        positionRight={bookingEngine.hotel.widgetPositionRight}
        positionBottom={bookingEngine.hotel.widgetPositionBottom}
        positionLeft={bookingEngine.hotel.widgetPositionLeft}
      >
        <WidgetContent
          handleOpen={handleOpen}
          existingMember={existingMember}
          gbEnrollChecked={gbEnrollChecked}
          userLoggedIn={userLoggedIn}
          bookingEngine={bookingEngine}
          hotelSettings={hotelSettings}
          locale={locale}
          isDesktopWidget={isDesktopWidget}
          autoExpandOnLoad={autoExpandOnLoad}
          setOuterAccordionExpanded={setOuterAccordionExpanded}
          outerAccordionExpanded={outerAccordionExpanded}
          widgetMobileAtWidth={widgetMobileAtWidth}
        />
      </FixedWidgetContainer>
    );
  } else {
    if (isDesktopWidget) {
      bookingEngine.createWidgetContainer();
    }
    const targetWidgetNode = bookingEngine.name === "skipper" ?
      bookingEngine.shadowRoot.querySelector("#guestbook-widget") :
      document.querySelector("#guestbook-widget");

    const targetStickyWidgetNode = document.querySelector(
      "#guestbook-sticky-widget"
    );
    if (stickyWidgetVisible) {
      return (
        targetStickyWidgetNode &&
        ReactDom.createPortal(
          <NonFixedWidgetcontainer isDesktopWidget={isDesktopWidget}>
            <WidgetContent
              handleOpen={handleOpen}
              existingMember={existingMember}
              gbEnrollChecked={gbEnrollChecked}
              userLoggedIn={userLoggedIn}
              bookingEngine={bookingEngine}
              hotelSettings={hotelSettings}
              locale={locale}
              isDesktopWidget={isDesktopWidget}
              autoExpandOnLoad={autoExpandOnLoad}
              setOuterAccordionExpanded={setOuterAccordionExpanded}
              outerAccordionExpanded={outerAccordionExpanded}
              widgetMobileAtWidth={widgetMobileAtWidth}
            />
          </NonFixedWidgetcontainer>,
          targetStickyWidgetNode as Element
        )
      );
    } else {
      return (
        targetWidgetNode &&
        ReactDom.createPortal(
          <NonFixedWidgetcontainer isDesktopWidget={isDesktopWidget}>
            <WidgetContent
              handleOpen={handleOpen}
              existingMember={existingMember}
              gbEnrollChecked={gbEnrollChecked}
              userLoggedIn={userLoggedIn}
              bookingEngine={bookingEngine}
              hotelSettings={hotelSettings}
              locale={locale}
              isDesktopWidget={isDesktopWidget}
              autoExpandOnLoad={autoExpandOnLoad}
              setOuterAccordionExpanded={setOuterAccordionExpanded}
              outerAccordionExpanded={outerAccordionExpanded}
              widgetMobileAtWidth={widgetMobileAtWidth}
            />
          </NonFixedWidgetcontainer>,
          targetWidgetNode as Element
        )
      );
    }
  }
};

export default Widget;
